import {Heading} from '@chakra-ui/react';
const NoPage = () => {
    return <Heading fontSize={'5xl'} alignContent={'center'} textAlign={'center'} mt="40vh">404: Page Not Found</Heading>;
  };
  
  export default NoPage;